export type ChatStep = {
  id: string
  /** Message(s) the assistant sends when this step begins. */
  prompt: string[]
  /** Tappable quick replies, or undefined for a free-text answer. */
  options?: string[]
  /** Placeholder for the text input when this step expects typing. */
  placeholder?: string
  inputType?: 'text' | 'tel'
}

export const chatIntro: string[] = [
  "Hi there — thanks for stopping by Unbelievable Remodeling & Painting.",
  "Tell us a little about your project and we'll get you a free estimate. What are you looking to have done?",
]

export const chatFlow: ChatStep[] = [
  {
    id: 'projectType',
    prompt: [],
    options: [
      'Interior Painting',
      'Exterior Painting',
      'Kitchen Remodeling',
      'Bathroom Remodeling',
      'Home Remodeling',
      'Something else',
    ],
  },
  {
    id: 'timeline',
    prompt: ['Great choice. When are you hoping to get started?'],
    options: ['As soon as possible', 'In the next month', 'In 2–3 months', 'Just planning'],
  },
  {
    id: 'name',
    prompt: ["Perfect. What's your name?"],
    placeholder: 'Your name',
    inputType: 'text',
  },
  {
    id: 'phone',
    prompt: [
      'Nice to meet you, {name}.',
      "What's the best number to reach you at? We'll follow up to schedule your walkthrough.",
    ],
    placeholder: '(502) 000-0000',
    inputType: 'tel',
  },
]

export const chatClosing: string[] = [
  "Thanks, {name} — you're all set.",
  "A member of our team will reach out shortly about your {projectType} project. If you'd rather talk now, give us a call.",
]
